import { resolveDeviceCommandInboxActive } from '../../shell/feature-flags/deviceCommandInbox';

/**
 * Honestidad de módulos (oleada 5 / Bloque D): ABM/compras/gastos piden red.
 * Activado con el paquete v2 (inbox on). Flags off = comportamiento legacy.
 */
export async function resolveModuleOnlineHonestyActive(): Promise<boolean> {
  return resolveDeviceCommandInboxActive();
}
